<template>
    <div>
        <a-table :columns="columns" 
                 :data-source="products" 
                 :pagination="{pageSize: pageSize}"
                 rowKey="itemId"
        >

            <template slot="index" slot-scope="text, record, index">
                <p>{{ index + 1 }}</p>
            </template>

            <template slot="image" slot-scope="record">
                <h6 class="m-0">
					<a-avatar :size="48" shape="square" :src="record.imageUrl" class="mr-10"></a-avatar>
				</h6>
            </template>

            <template slot="actions" slot-scope="record">
				<a-button-group>
					<a-button shape="circle" icon="form" size="small" @click="handleBtnEdit(record)"/>
                    <a-button shape="circle" icon="edit" size="small" @click="handleBtnUpdateParent(record)"/>
				</a-button-group>
			</template>

        </a-table>

        <product-edit-view-modal ref="productEditModal"/>
        <sub-product-update-view-modal ref="subProductModal"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ProductEditViewModal from './ProductEditViewModal.vue'
import SubProductUpdateViewModal from './SubProductUpdateViewModal.vue';
export default {

    components : {
        ProductEditViewModal,
        SubProductUpdateViewModal
    },

    data () {
        return {
            pageSize: 5, 
            columns : [
                {
					title: '#',
					dataIndex: 'index',
                    scopedSlots: { customRender: 'index' },
				},
                {
			        title : '',
			        scopedSlots : { customRender: 'image'},
		        },
                {
					title: 'PRODUCT',
					dataIndex: 'itemName',
				},
                {
					title: 'CATEGORY',
					dataIndex: 'category',
				},
                {
					title: 'PRICE',
					dataIndex: 'originalPrice',
				},
                {
			        title : 'ACTIONS',
			        scopedSlots : { customRender: 'actions'},
			        fixed: 'right'
		        }
            ]
        }
    },
    computed : {
        ...mapGetters({
            //productsByCategory : 'products/productsByCategory'
        }),
        ...mapState({
            products : state => state.products.products
        })
    },

    methods : {
        handleBtnEdit(record) {

            let product = this.$store.state.products.products.find(p => p.itemId === record.itemId);
            //console.log(product)
            //let newProduct = Object.assign({}, product)
            if (product != null) {
                this.$refs['productEditModal'].showModal(product);
            }
        },
        handleBtnUpdateParent(record) {
            let product = this.$store.state.products.products.find(p => p.itemId === record.itemId);
            if (product != null) {
                
                this.$refs['subProductModal'].showModal(product);
            }
        }
    }

}
</script>